import HealthDetails from './HealthDetails';

export default HealthDetails;
